import React from "react";
import { Link } from "react-router-dom";

import { routes } from "consts";
import { EXAM_STATUS, ExamStatusIds } from "consts";
import { TanTableClient, TanTableColumn } from "components/molecules";
import { CourseStudentExamData } from "api/course-exams";
import { ExamAttemptStatusSquare } from "./ExamAttemptStatusSquare";

interface StudentExamsTableProps {
  exams: CourseStudentExamData[];
  courseId: number;
  courseExamId: number;
  setSelectedExams?: (exams: number[]) => void;
  hideBorder?: boolean;
}
export const StudentExamsTable = ({
  exams,
  courseId,
  courseExamId,
  setSelectedExams,
  hideBorder,
}: StudentExamsTableProps) => {
  const columns = getStudentExamsColumns(courseId, courseExamId);

  return <TanTableClient data={exams} columns={columns} onSelectionChange={setSelectedExams} hideBorder={hideBorder} />;
};

export const getStudentExamsColumns = (
  courseId: number,
  courseExamId: number,
): TanTableColumn<CourseStudentExamData>[] => [
  {
    id: "userId",
    accessorKey: "userId",
    header: "ID",
    size: 10,
    enableColumnFilter: false,
  },
  {
    id: "email",
    accessorKey: "email",
    header: "Email",
    enableColumnFilter: false,
    cell: (info) => (
      <Link to={routes.STUDENT_NESTED.EXAMS(info.row.original.userId, courseId)}>{info.getValue<string>()}</Link>
    ),
  },
  {
    id: "name",
    accessorKey: "name",
    header: "Kursant",
    enableColumnFilter: false,
  },
  {
    id: "lastAttempt",
    accessorKey: "lastAttempt",
    header: "Ostatnia próba",
    enableColumnFilter: false,
    cell: (info) => {
      const lastAttempt = info.getValue<ExamStatusIds | undefined>();
      if (!lastAttempt) return <span className="font-semibold text-blue-500">Nie uzupełniono</span>;
      return <div>{examStatuses[lastAttempt]}</div>;
    },
  },
  {
    id: "attempts",
    accessorKey: "attempts",
    header: "Próby",
    enableColumnFilter: false,
    cell: (info) => (
      <div className="flex gap-1">
        {info.row.original.attempts.map((x, i) => (
          <ExamAttemptStatusSquare
            exam={x}
            key={i}
            userId={info.row.original.userId}
            courseId={courseId}
            courseExamId={courseExamId}
          />
        ))}
      </div>
    ),
  },
];

export const examStatuses: Record<ExamStatusIds, React.JSX.Element> = {
  [EXAM_STATUS.NOT_REVIEWED]: <span className="font-semibold text-orange-500">Nie sprawdzono</span>,
  [EXAM_STATUS.PASSED_NOT_PUBLISHED]: (
    <span className="font-semibold text-emerald-300">Zaliczony (nieopublikowany)</span>
  ),
  [EXAM_STATUS.FAILED_NOT_PUBLISHED]: (
    <span className="font-semibold text-rose-300">Nie zaliczony (nieopublikowany)</span>
  ),
  [EXAM_STATUS.PASSED]: <span className="font-semibold text-emerald-500">Zaliczony</span>,
  [EXAM_STATUS.SKIPPED]: <span className="font-semibold text-gray-500">Pominięty</span>,
  [EXAM_STATUS.FAILED]: <span className="font-semibold text-rose-500">Nie zaliczony</span>,
};
